export default __webpack_public_path__ + "static/play-c2cab3f7103f33403914fd2101fc17b6.png";